import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { CustomTooltip } from "../../../../../../common/components";
import { translateDate, translateElapsed } from "../../../../../../common/providers";
import styles from "./NoteRow.module.css";

const getPrevRow = (el) => el?.parentElement?.previousElementSibling?.firstElementChild;

const NoteRow = ({ note, onClick }) => {
	const selectedNoteId = useSelector(({ note: n }) => n.selectedNote?.id);
	const isActive = selectedNoteId === note.id;
	const rowRef = useRef(null);

	useEffect(() => {
		const prev = getPrevRow(rowRef.current);
		if (isActive) {
			prev?.setAttribute("data-next-active", "true");
		} else {
			prev?.removeAttribute("data-next-active");
		}
		return () => prev?.removeAttribute("data-next-active");
	}, [isActive]);

	const displayDate = () => {
		if (note.elapsed?.unit === "DAYS" && note.elapsed?.value > 7) {
			return translateDate(note.lastModified);
		}
		return translateElapsed({ value: note.elapsed?.value, unitKey: note.elapsed?.unit });
	};

	const handleMouseEnter = () => {
		getPrevRow(rowRef.current)?.setAttribute("data-next-hovered", "true");
	};

	const handleMouseLeave = () => {
		getPrevRow(rowRef.current)?.removeAttribute("data-next-hovered");
	};

	return (
		<div
			key={note.id}
			ref={rowRef}
			className={styles.row}
			data-active={isActive}
			data-selected={selectedNoteId === note.id}
			role="presentation"
			onClick={() => onClick(note)}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<CustomTooltip showWhenOverflow title={note.title}>
				<div className={styles.title}>{note.title}</div>
			</CustomTooltip>
			<div className={styles.date}>{displayDate()}</div>
		</div>
	);
};

export default NoteRow;
